import _defineProperty from "/codebuild/output/src237558920/src/pavilions-web-app/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/codebuild/output/src237558920/src/pavilions-web-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["className", "bsPrefix", "backdrop", "backdropClassName", "keyboard", "scroll", "placement", "autoFocus", "enforceFocus", "restoreFocus", "restoreFocusOptions", "onShow", "onHide", "onEscapeKeyDown", "onEnter", "onEntering", "onEntered", "onExit", "onExiting", "onExited"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import * as React from 'react';
import { useContext } from 'react';
import useBreakpoint from '@restart/hooks/useBreakpoint';
import classNames from 'classnames';
import { useBootstrapPrefix } from './ThemeProvider';
import Offcanvas from './Offcanvas';
import NavbarContext from './NavbarContext';
import { jsx as _jsx } from "react/jsx-runtime";
var NavbarOffcanvas = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var className = _ref.className,
      bsPrefix = _ref.bsPrefix,
      backdrop = _ref.backdrop,
      backdropClassName = _ref.backdropClassName,
      keyboard = _ref.keyboard,
      scroll = _ref.scroll,
      placement = _ref.placement,
      autoFocus = _ref.autoFocus,
      enforceFocus = _ref.enforceFocus,
      restoreFocus = _ref.restoreFocus,
      restoreFocusOptions = _ref.restoreFocusOptions,
      onShow = _ref.onShow,
      onHide = _ref.onHide,
      onEscapeKeyDown = _ref.onEscapeKeyDown,
      onEnter = _ref.onEnter,
      onEntering = _ref.onEntering,
      onEntered = _ref.onEntered,
      onExit = _ref.onExit,
      onExiting = _ref.onExiting,
      onExited = _ref.onExited,
      props = _objectWithoutProperties(_ref, _excluded);

  var context = useContext(NavbarContext);
  bsPrefix = useBootstrapPrefix(bsPrefix, 'offcanvas');
  var hasExpandProp = typeof (context == null ? void 0 : context.expand) === 'string';
  var shouldExpand = useBreakpoint(hasExpandProp ? context.expand : 'xs', 'up');
  return hasExpandProp && shouldExpand ? /*#__PURE__*/_jsx("div", _objectSpread(_objectSpread({
    ref: ref
  }, props), {}, {
    className: classNames(className, bsPrefix, "".concat(bsPrefix, "-").concat(placement))
  })) : /*#__PURE__*/_jsx(Offcanvas, _objectSpread({
    ref: ref,
    show: !!(context != null && context.expanded),
    bsPrefix: bsPrefix,
    backdrop: backdrop,
    backdropClassName: backdropClassName,
    keyboard: keyboard,
    scroll: scroll,
    placement: placement,
    autoFocus: autoFocus,
    enforceFocus: enforceFocus,
    restoreFocus: restoreFocus,
    restoreFocusOptions: restoreFocusOptions,
    onShow: onShow,
    onHide: onHide,
    onEscapeKeyDown: onEscapeKeyDown,
    onEnter: onEnter,
    onEntering: onEntering,
    onEntered: onEntered,
    onExit: onExit,
    onExiting: onExiting,
    onExited: onExited
  }, props));
});
NavbarOffcanvas.displayName = 'NavbarOffcanvas';
export default NavbarOffcanvas;